import { errorRangoFechasFiltro } from "@/util/validarRangoFechasFiltro";
import { createAxios } from "./axiosHttpMarconi";

export const incotermsSendedService = {
  getIncoterms,
};

function getIncoterms(pagination, filters) {
  const error = errorRangoFechasFiltro(filters);
  if (error) return Promise.reject(error);
  const axios = createAxios();
  const user = JSON.parse(localStorage.getItem("user"));
  let urlPath = `franquicia/${user.extraData.franquiciaId}/incoterms-sended`;
  const pagination_service = {
    page: pagination.currentPage - 1,
    limit: pagination.perPage,
  };

  const params = new URLSearchParams({ ...pagination_service, ...filters });

  urlPath += `?${params.toString()}`;
  return axios.get(urlPath);
}
